module.exports = __webpack_public_path__ + "static/media/car-woman.9c6ea0e3.svg";